import {junHistoryLogic, junLsLogic} from "@jixo/jun";
import {execaNode, type ResultPromise} from "execa";
import fsp from "node:fs/promises";
import {createRequire} from "node:module";
import os from "node:os";
import path from "node:path";
import {afterEach, beforeEach, describe, expect, it} from "vitest";

const require = createRequire(import.meta.url);

async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

describe("shellRun tool", () => {
  let testDir: string;
  let originalCwd: string;
  let cliPath: string;
  let backgroundProcesses: ResultPromise[] = [];

  beforeEach(async () => {
    testDir = await fsp.mkdtemp(path.join(os.tmpdir(), "shell_run_test_"));
    originalCwd = process.cwd();
    process.chdir(testDir);
    cliPath = require.resolve("@jixo/jun/cli");
    await execaNode(cliPath, ["init"]);
  });

  afterEach(async () => {
    process.chdir(originalCwd);
    await fsp.rm(testDir, {recursive: true, force: true});
    await Promise.allSettled(backgroundProcesses.map((p) => p.kill("SIGKILL")));
  });

  it("should run a foreground command and wait for completion", async () => {
    const {exitCode} = await execaNode(cliPath, ["run", "echo", "hello"]);
    expect(exitCode).toBe(0);

    const history = await junHistoryLogic();
    expect(history.length).toBe(1);
    const task = history[0];
    expect(task).toBeDefined();
    expect(task.status).toBe("completed");
  });

  it("should run a background command and return immediately", async () => {
    const bgProcess = execaNode(cliPath, ["run", "--background", "sleep", "10"], {cwd: testDir});
    backgroundProcesses.push(bgProcess);
    await sleep(500); // Give it time to register

    const runningTasks = await junLsLogic();
    expect(runningTasks.running_tasks.length).toBe(1);
    const task = runningTasks.running_tasks[0];
    expect(task?.status).toBe("running");
    expect(task?.command).toBe("sleep");
  });
});
